import React, { useState, useEffect } from "react";
import { ScrollButton } from "./styles/BackToTopStyles";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <ScrollButton 
      onClick={scrollToTop} 
      isVisible={isVisible}
      aria-label="Back to top"
    >
      <KeyboardArrowUpIcon style={{ color: '#FFFFFF', fontSize: '28px' }} />
    </ScrollButton>
  );
};

export default BackToTop;
